import { createRouter, createWebHistory } from 'vue-router'
import { hasAnyRole } from '@/services/userRoles'

import clientDashboard from '@/views/dashboard/client-dashboard.vue'
import LoginPage from '../views/authentication/LoginPage.vue'
import SetPassword from '../views/authentication/SetPassword.vue'
import ForgotPassword from '../views/authentication/ForgotPassword.vue'

import supplysMain from '../views/supplys/supplysMain.vue'
import supplysComunidades from '@/views/supplys/property/supplys-comunidades.vue'
import supplysComunidadesDetail from '@/views/supplys/property/supplysComunidadesDetail.vue'
import supplysGas from '@/views/supplys/gas/supplys-gas.vue'
import supplysGasDetail from '@/views/supplys/gas/supplysGasDetail.vue'
import supplysLuz from '../views/supplys/light/supplysLuz.vue'
import supplysLightDetail from '@/views/supplys/light/supplysLightDetail.vue'
import clientAdmin from '@/views/supplys/clientAdmins/clientAdmin.vue'
import requestView from '../views/request/request-view.vue'
import requestDetail from '@/views/request/request-detail.vue'
import requestDetailSuperadmin from '@/views/request/request-detail-superadmin.vue'
import userView from '../views/user/user-view.vue'
import UserDirectoryDetail from '@/views/user/UserDirectoryDetail.vue'
import userDetail from '@/views/user/userDetail.vue'
import liquidationView from '@/views/liquidation/liquidationView.vue'
import reportView from '@/views/report/reportView.vue'
import PropertyFormView from '@/views/supplys/property/PropertyFormView.vue'
import addLightView from '@/views/supplys/light/addLightView.vue'
import addGasView from '@/views/supplys/gas/addGasView.vue'
import userNew from '@/views/user/user-new.vue'
import usersAds from '@/views/user/usersAds.vue'
import NewAdsUser from '@/views/user/NewAdsUser.vue'
import { canAccessOperationalReport } from '@/services/operationalReportAccess'
import { supplySectionPath, showsSupplyRequests } from '@/services/supplySections'

import SettingsView from '@/views/settings/SettingsView.vue'

import allForms from '@/views/form/all-forms.vue'

import AdminDetail from '@/views/supplys/clientAdmins/AdminDetail.vue'
import NewBill from '@/views/supplys/bill/NewBill.vue'
import SupplyBill from '@/views/supplys/bill/SupplysBill.vue'
import BillDetail from '@/views/supplys/bill/BillDetail.vue'
import NewAdmin from '@/views/supplys/clientAdmins/NewAdmin.vue'


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: clientDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/supplies',
      name: 'supplies',
      redirect: '/forms/supplies',
      meta: { requiresAuth: true }
    },
    {
      path: '/change_ownership',
      name: 'change_ownership',
      redirect: '/forms/change_ownership',
      meta: { requiresAuth: true }
    },
    // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
    // {
    //   path: '/change_supplier',
    //   name: 'change_supplier',
    //   redirect: '/forms/change_supplier',
    //   meta: { requiresAuth: true }
    // },
    {
      path: '/account_change',
      name: 'account_change',
      redirect: '/forms/account_change',
      meta: { requiresAuth: true }
    },
    {
      path: '/invoice',
      name: 'invoice',
      redirect: '/forms/invoice',
      meta: { requiresAuth: true }
    },
    {
      path: '/other_type',
      name: 'other_type',
      redirect: '/forms/other_type',
      meta: { requiresAuth: true }
    },
    {
      path: '/forms/:type?',
      name: 'forms',
      component: allForms,
      meta: { requiresAuth: true }
    },


    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { requiresAuth: false, hideLayout: true }
    },

    {
      path: '/set-password',
      name: 'set-password',
      component: SetPassword,
      meta: { requiresAuth: false, hideLayout: true }
    },

    {
      path: '/supplys',
      name: 'supplys',
      component: supplysMain,
      meta: { requiresAuth: true }
    },

    {
      path: '/gas',
      name: 'gas',
      component: supplysGas,
      meta: { requiresAuth: true },
      beforeEnter: () => (showsSupplyRequests() ? supplySectionPath('gas') : true)
    },
    {
      path: '/gas-detail/:id',
      name: 'gas-detail',
      component: supplysGasDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/add-gas/:id?',
      name: 'add-gas',
      component: addGasView,
      meta: { requiresAuth: true }
    },

    {
      path: '/Property/:type?',
      name: 'Property',
      component: supplysComunidades,
      meta: { requiresAuth: true }
    },
    {
      path: '/Property-detail/:id',
      name: 'Property-detail',
      component: supplysComunidadesDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/Property-new/:id?/:type?',
      name: 'ComunidadesNewOrEdit',
      component: PropertyFormView,
      meta: { requiresAuth: true }
    },


    {
      path: '/luz',
      name: 'luz',
      component: supplysLuz,
      meta: { requiresAuth: true },
      beforeEnter: () => (showsSupplyRequests() ? supplySectionPath('light') : true)
    },
    {
      path: '/light-detail/:id',
      name: 'light-detail',
      component: supplysLightDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/add-light/:id?',
      name: 'add-light',
      component: addLightView,
      meta: { requiresAuth: true }
    },

    {
      path: '/supply-bill',
      name: 'supply-bill',
      component: SupplyBill,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin', 'comercial'] }
    },
    {
      path: '/new-bill',
      name: 'new-bill',
      component: NewBill,
      meta: { requiresAuth: true }
    },
    {
      path: '/detail-bill/:id',
      name: 'detail-bill',
      component: BillDetail,
      meta: { requiresAuth: true }
    },

    {
      path: '/request',
      name: 'request',
      component: requestView,
      meta: { requiresAuth: true }
    },
    {
      path: '/request-detail/:id',
      name: 'request-detail',
      component: requestDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/request-detail-superadmin/:id',
      name: 'request-detail-superadmin',
      component: requestDetailSuperadmin,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin'] }
    },


    {
      path: '/client-admin',
      name: 'client-admin',
      component: clientAdmin,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin', 'comercial'] }
    },
    {
      path: '/users-ads',
      name: 'users-ads',
      component: usersAds,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin', 'comercial'] }
    },
    {
      path: '/new-admin',
      name: 'new-admin',
      component: NewAdmin,
      meta: { requiresAuth: true }
    },
    {
      path: '/new-user',
      name: 'new-user',
      component: NewAdmin,
      meta: { requiresAuth: true }
    },
    {
      path: '/new-ads-user',
      name: 'new-ads-user',
      component: NewAdsUser,
      // Back Office también da de alta usuarios ADS (ADSREC-0007).
      meta: { requiresAuth: true, requiredRoles: ['superadmin', 'admin'] }
    },
    {
      path: '/detail-admin/:id',
      name: 'detail-admin',
      component: AdminDetail,
      meta: { requiresAuth: true }
    },

    {
      path: '/liquidation',
      name: 'liquidation',
      component: liquidationView,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin', 'comercial'] }
    },

    {
      path: '/report',
      name: 'report',
      component: reportView,
      meta: { requiresAuth: true, requiresOperationalReportAccess: true }
    },

    {
      path: '/user',
      name: 'user',
      component: userView,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-detail/:id',
      name: 'user-detail',
      component: userDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-directory/:id',
      name: 'user-directory',
      component: UserDirectoryDetail,
      meta: { requiresAuth: true, requiredRoles: ['admin', 'superadmin'] }
    },
    {
      path: '/admin-detail/:id',
      name: 'admin-detail',
      component: AdminDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-new',
      name: 'user-new',
      component: userNew,
      meta: { requiresAuth: true }
    },

    {
      path: '/settings',
      name: 'settings',
      component: SettingsView,
      meta: { requiresAuth: true }
    },

    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: { requiresAuth: false, hideLayout: true }
    }

  ],
})

router.beforeEach(async (to) => {
  const isAuthenticated = localStorage.getItem('token')
  const role = localStorage.getItem('role')

  if (to.meta.requiresAuth && !isAuthenticated) {
    // Se conserva el destino para volver a él tras identificarse (enlaces
    // directos a una solicitud desde los avisos por email).
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  if (to.meta.requiredRole && role !== to.meta.requiredRole) {
    return '/request'
  }

  if (to.meta.requiredRoles && !hasAnyRole(to.meta.requiredRoles)) {
    return '/request'
  }

  // Los enlaces del listado y de los avisos abren el detalle completo para
  // Back Office. La API decide si es editable o de solo lectura.
  if (to.name === 'request-detail' && hasAnyRole(['admin', 'superadmin'])) {
    return { name: 'request-detail-superadmin', params: to.params, query: to.query, hash: to.hash }
  }

  if (to.meta.requiresOperationalReportAccess) {
    try {
      if (!(await canAccessOperationalReport())) return '/request'
    } catch {
      return '/request'
    }
  }

  if (to.name === 'login' && isAuthenticated) {
    const redirect = to.query.redirect
    return typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')
      ? redirect
      : '/'
  }

  return true
})

export default router
